export enum ReferenceLookupResultType {
  MatchFound = 0,
  NoMatchFound = 1,
  MultipleMatchesFound = 2
}